import { CImg } from "@coreui/react";
import { useFormContext } from "react-hook-form";
import ZbIcon from "src/assets/images/zb_icon.png";
import { ButtonOutline } from "src/components";
import FormStepWrapper from "src/components/FormStepWrapper/FormStepWrapper";
import { AboveCard } from ".";

const Complete = () => {

  const { nextClickHandler } = useFormContext();


  return (
    <FormStepWrapper
      showTop={false}
      showReportingPeriod={false}
      showMenuButton
      aboveCardSlot={<AboveCard />}
    >
      <h1 className="mb-2 text-center">Thank you for your time</h1>
      <h2 className="mb-4 text-center">The survey is complete.</h2>

      <ButtonOutline
        size="lg"
        className="mb-5"
        onClick={() => {
          nextClickHandler();
        }}
      >
        View Results
      </ButtonOutline>
      <p
        style={{
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: 1.5,
          color: "#3C4B64",
        }}
        className="text-center mb-1"
      >
        Visit us at ZeroBees to learn how we can support you on your
        sustainability journey.
      </p>
      <a
        target="_blank"
        rel="noreferrer"
        color="primary"
        className="d-flex align-items-center p-3 text-info"
        href="https://www.zerobees.com/"
      >
        <span style={{ fontSize: "24px", fontWeight: 600 }} className=" mr-2">
          ZeroBees
        </span>
        <CImg
          size="2rem"
          style={{ width: "24px", height: "24px", lineHeight: 1 }}
          src={ZbIcon}
        />
      </a>
    </FormStepWrapper>
  );
};

export default Complete;
